(function(){
    'use strict';

    angular
    .module('appback')
    .controller('MaquinalisController', MaquinalisController)
 
    MaquinalisController.$inject = ["GenerallabService","MaquinalisService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function MaquinalisController(GenerallabService,MaquinalisService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this;
        vm.generalLab = GenerallabService;
        vm.micro = {};
        vm.selanalitica = {};
       	vm.aliasMicro = function(id){
       		console.log("chanbge",vm.micro);
       		if(angular.isDefined(vm.micro[id])){
       			console.log("micro",vm.micro[id]);
       		}
       	}
        vm.selectAnaliticaMicro=function(id,maquina){
          MaquinalisService.guardarAnSel(id,vm.selanalitica[id],maquina,function(data){
            //location.reload();
          });
        }

        vm.guardar = function(id,alias){
       		if(angular.isDefined(vm.micro[id])){
        		MaquinalisService.guardarAlias(vm.micro[id],alias,function(data){
        			location.reload();
        		});
        		
        	}
        }
    }
  
})();